import type { GTMEventReturnType } from '../GTM.types';
import { hashEmail } from '../../util/encrypt';
import GTMBaseModel from '../GTMBaseModel';

interface GTMNewsletterSignupReturnType extends GTMEventReturnType {
    user_hash: string;
}

interface GTMNewsletterSignupModelData {
    email: string;
}

export default class GTMNewsletterSignupModel extends GTMBaseModel {
    public static async parseToGTMData({
        email
    }: GTMNewsletterSignupModelData): Promise<GTMNewsletterSignupReturnType> {
        const emailHash = await hashEmail(email);

        return {
            ...GTMBaseModel.getBaseData(),
            ga4_property: 'web_event',
            ga4_event_name: 'newsletter_signup',
            user_hash: emailHash
        };
    }
}
